import styled from "styled-components"

export const ContainerWrapper = styled.div`
  height: 100%;
  display: grid;
  grid-template-columns: 1fr repeat(12, minmax(auto, 6.72rem)) 1fr;
  grid-template-rows: 12.48rem 32rem 8rem auto;
  gap: 0 3.2rem;

  @media ${props => props.theme.breakpoints.tablet} {
    grid-template-columns: 3.2rem repeat(6, 1fr) 3.2rem;
    grid-gap: 0 1.6rem;
  }

  @media ${props => props.theme.breakpoints.mobile} {
    grid-template-columns: 0.3rem repeat(6, 1fr) 0.3rem;
    grid-gap: 0 0.3rem;
    grid-template-rows: 8rem 32rem 8rem auto;
  }
`
